import { render, staticRenderFns } from "./WelcomeLanding.vue?vue&type=template&id=58bd5a0b"
import script from "./WelcomeLanding.vue?vue&type=script&lang=js"
export * from "./WelcomeLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports